module.exports = __webpack_public_path__ + "img/studentmenu_lo.0164de80.jpg";